import { render, staticRenderFns } from "./EditTransmitterConfig.vue?vue&type=template&id=2ee98ab5&scoped=true&lang=pug"
import script from "./EditTransmitterConfig.vue?vue&type=script&lang=js"
export * from "./EditTransmitterConfig.vue?vue&type=script&lang=js"
import style0 from "./EditTransmitterConfig.vue?vue&type=style&index=0&id=2ee98ab5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee98ab5",
  null
  
)

export default component.exports